<template>
  <div id="GoTop" :class="{ visible: visible }" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.visible = scrollTop > 300
    },
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 44px;
  height: 44px;
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 997;
  cursor: pointer;
  background: linear-gradient(135deg, #1a6fb5, #2E7D32);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(56, 189, 248, 0.3);
  box-shadow: 0 4px 20px rgba(26, 111, 181, 0.35);
  transition: var(--transition);
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
}
#GoTop.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
#GoTop:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 28px rgba(56, 189, 248, 0.4);
}
#GoTop > span {
  color: #fff;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue